import * as THREE from "three";
import GLTFLoader from "three-gltf-loader";
import * as mapboxgl from "mapbox-gl";
import * as turf from "@turf/turf";
import { Text } from "troika-three-text";
export default class RTGLayer {
  id = "";
  type = "custom";
  renderingMode = "3d";
  rtg: any;
  renderer: any;
  map: any;
  scene = new THREE.Scene();
  model = null;
  cam: any;
  textObjects: Text[] = [];
  maxLevel = 6;
  maxRow = 6;
  anglex: number;
  center: any;
  color:"#000000";
  constructor(center: any, anglex: number, rtg: any,color:any) {
    this.center = center;
    this.rtg = rtg;
    if (this.rtg.MaxStackLevel)
      this.maxLevel = Number(this.rtg.MaxStackLevel) + 1;
    THREE.Cache.enabled = true;
    this.cam = this.getCam();
    this.anglex = anglex + 2 * (90 - anglex);
    this.id = rtg.Code;
    this.color = color;
  }

  addlights() {
    const skyColor1 = 0xffffff;
    const groundColor1 = 0x181817;
    const intensity1 = 1;
    const light1 = new THREE.HemisphereLight(
      skyColor1,
      groundColor1,
      intensity1
    );
    this.scene.add(light1);
    const light2 = new THREE.AmbientLight(0xffffff);
    this.scene.add(light2);
  }
  addRTGName() {
    const topText = new Text();
    topText.text = this.id;
    topText.fontSize = 0.1;
    topText.outlineColor = 0xffffff;
    topText.outlineWidth = 0.02;
    //myText.letterSpacing = -0.1;
    topText.scale.set(30, 30, 30);
    topText.textAlign = "center";
    topText.anchorX = "center";
    topText.anchorY = "middle";
    topText.position.set(0, 0, -( 1 + this.maxLevel) * 3.5);
    topText.color = 0x000000;
    this.scene.add(topText);
    this.textObjects.push(topText);
  }

  onAdd(map, gl: WebGLRenderingContext) {
    this.map = map;

    this.addlights();
    const loader = new GLTFLoader();
    const select = 7; //Math.floor(Math.random() * 7)+1;
    const gltf = `object3d/RTGS/RTG${select}/RTG.gltf`;

    loader.load(
      gltf,
      (gltf) => {
        this.model = gltf.scene
        this.scene.add(this.model);
        this.model.traverse((child) => {
          if (child.isMesh) {
            child.material.color.set(this.color);
          }
        });
        const factorw = 1;
        this.scene.scale.set(
          ((factorw * this.maxRow) / 6) * 1.7,
          factorw,
          factorw * (this.maxLevel / 6)
        );
        this.addRTGName();
      },
      (xhr) => {
        console.log(`${(xhr.loaded / xhr.total) * 100}% loaded`);
      },
      (error) => {
        console.error("An error happened", error);
      }
    );

    this.renderer = new THREE.WebGLRenderer({
      canvas: map.getCanvas(),
      context: gl,
      antialias: true,
    });

    this.renderer.autoClear = false;
  }

  render(gl, matrix) {
    const ry = (this.anglex * Math.PI) / 180;

    const rotateText = (this.map.getBearing() * Math.PI) / 180;
    this.textObjects.forEach((item: Text) => {
      item.scale.set(12, 12, 12);
      item.rotation.set(-Math.PI / 2, (2 * Math.PI) / 2 - rotateText - ry, 0);

      if (item.sync) {
        item.fontSize = (0.2 * this.map.getZoom()) / 20;
        item.sync();
      }
    });

    const startpos = new mapboxgl.LngLat(
      Number(this.center[0]),
      Number(this.center[1])
    );
    const modelAsMercatorCoordinate = mapboxgl.MercatorCoordinate.fromLngLat(
      startpos,
      0
    );
    const modelTransform = {
      translateX: mapboxgl.MercatorCoordinate.fromLngLat(startpos, 0).x,
      translateY: mapboxgl.MercatorCoordinate.fromLngLat(startpos, 0).y,
      translateZ: mapboxgl.MercatorCoordinate.fromLngLat(startpos, 0).z,
      rotateX: 0,
      rotateY: Math.PI,
      rotateZ: -ry,
      // scale: modelAsMercatorCoordinate.meterInMercatorCoordinateUnits() * 1.3383e-7 * factorw * 0.92, // 13.7
      scale: modelAsMercatorCoordinate.meterInMercatorCoordinateUnits(),
    };

    const currentMatrix = new THREE.Matrix4().fromArray(matrix);
    const cam = this.cam === null ? new THREE.Camera() : this.cam;
    cam.projectionMatrix.elements = matrix;
    cam.projectionMatrix = currentMatrix.multiply(
      this.getNewMatrix(modelTransform)
    );
    if (this.renderer) {
      this.renderer.state.reset();
      this.renderer.render(this.scene, cam);
    }
    //this.map.triggerRepaint();
  }
  getNewMatrix(modelTransform: any): THREE.Matrix4 {
    const rotationX = new THREE.Matrix4().makeRotationX(modelTransform.rotateX);
    const rotationY = new THREE.Matrix4().makeRotationY(modelTransform.rotateY);
    const rotationZ = new THREE.Matrix4().makeRotationZ(modelTransform.rotateZ);

    const newMatrix = new THREE.Matrix4()
      .makeTranslation(
        modelTransform.translateX,
        modelTransform.translateY,
        Number(modelTransform.translateZ)
      )
      .scale(
        new THREE.Vector3(
          modelTransform.scale,
          -modelTransform.scale,
          modelTransform.scale
        )
      )
      .multiply(rotationX)
      .multiply(rotationY)
      .multiply(rotationZ);
    return newMatrix;
  }

  getCam() {
    const cam = new THREE.Camera();
    return cam;
  }
}
